import ReactMarkdown from 'react-markdown'
import rehypeSanitize from 'rehype-sanitize'
import remarkGfm from 'remark-gfm'

import { cn } from '@/shared/lib/cn'

export interface MarkdownProps {
  children: string | null | undefined
  className?: string
  /** Texto cuando no hay contenido. */
  empty?: string
}

/**
 * Prosa markdown a 72ch.
 *
 * `rehype-sanitize` NO es opcional: esto renderiza texto escrito por personas y
 * que en el portal terminan leyendo clientes.
 */
export function Markdown({ children, className, empty = 'Sin contenido.' }: MarkdownProps) {
  if (!children?.trim()) {
    return <p className={cn('text-xs text-text-3', className)}>{empty}</p>
  }

  return (
    <div
      className={cn(
        'prose-console text-text-2',
        '[&_h2]:mt-5 [&_h2]:mb-2 [&_h2]:text-md [&_h2]:text-text-1',
        '[&_h3]:mt-4 [&_h3]:mb-1.5 [&_h3]:text-base [&_h3]:text-text-1',
        '[&_p]:mb-3 [&_ul]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:mb-3 [&_ol]:list-decimal [&_ol]:pl-5',
        '[&_li]:mb-1 [&_strong]:text-text-1 [&_a]:text-signal [&_a]:underline',
        '[&_code]:font-mono [&_code]:text-xs [&_code]:text-text-1',
        '[&_blockquote]:border-l-2 [&_blockquote]:border-hairline [&_blockquote]:pl-3 [&_blockquote]:text-text-3',
        '[&_table]:w-full [&_th]:border-b [&_th]:border-hairline [&_th]:py-1 [&_th]:text-left',
        '[&_td]:border-b [&_td]:border-hairline [&_td]:py-1',
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSanitize]}>
        {children}
      </ReactMarkdown>
    </div>
  )
}
